<template>
    <div class="app">
        <hospital-select @selected="go" :continueSelect="true" :noSelectedOpen="false" :alwaysOpen="true"></hospital-select>
        <!--<map-window v-model="showWindow" :data-list="areaList">-->
            <!--<span slot="title"><span class="f-strong">请选择您要导航去的院区</span></span>-->
            <!--<ul slot="list" class="list" style="padding: 1.5% 3% 1.5% 3%;">-->
                <!--<li v-for="item in areaList" class="list-item guide-bg" :class="'arr-item-guide'"-->
                    <!--@click="selectArea(item)">-->
                    <!--<span>{{item.areaName}}</span>-->
                    <!--<br>-->
                    <!--<span>{{item.areaAddr}}</span>-->
                <!--</li>-->
            <!--</ul>-->
        <!--</map-window>-->
    </div>
</template>
<script>
import HospitalSelect from 'HospitalSelect'
import MapWindow from 'MapWindow'
export default {
    components: {
        HospitalSelect,
        MapWindow
    },
    data() {
        return {
            selectedHospital:{},
            areaList:[],
            showWindow: false,
            busiType:'',
            //跳转挂号业务类型
            BUSI_TYPE:{
                register:'1',
                myRegister:'2'
            }
        }
    },
    methods: {
        go() {
            this.selectedHospital = JSON.parse(localStorage.selectedHospital);
            this.areaList = JSON.parse(localStorage.selectedHospital).areaList;
            this.busiType = sessionStorage.getItem('busiType')

            let type = localStorage.getItem("channel")

            // 天府蓉易办和天府通办APP进来的，部分医院因商户号H5支付配置有误拉不起支付，需要屏蔽
            if (type === 'TFTB' || type === 'TFRYB') {
                // 彭州市人民医院和彭州市天彭社区卫生服务中心商户号未开通H5支付
              // if(this.selectedHospital.hospitalId === '1010') {
              //   this.$router.push('maintaing')
              //   return
              // }
                // if(this.selectedHospital.hospitalId === '1003' || this.selectedHospital.hospitalId === '1010') {
                //     this.$router.push('maintaing')
                //     return
                // }
                // 彭州市白鹿镇卫生院，彭州市龙门山镇卫生院，彭州市军乐镇卫生院，本身公众号中拉起支付就有问题
                if(this.selectedHospital.hospitalId === '1027' || this.selectedHospital.hospitalId === '1026' || this.selectedHospital.hospitalId === '1020') {
                    this.$router.push('maintaing')
                    return
                }
            }

          //1006 &&this.$store.state.paramModule.param.menu.url === 'myregister'
         //  if(this.selectedHospital.hospitalId=='1004'){
         //   this.$router.push('maintaing')
         //   return
         // }
          //2022年8.16 9.12分打开
         //  if(this.selectedHospital.hospitalId=='1006'){
         //   this.$router.push('maintaing')
         //    //window.location.replace("https://zyjkihup.com/plagh/?hospitalCode=40001&appId=wx2bb1509173bcf701&wechatLogin=Y")
         //    return
         //  }
         /* if(this.selectedHospital.hospitalId=='1006'){
            this.$router.push('maintaing')
            return
          }*/
          /*if(this.selectedHospital.hospitalId=='1006'&&this.$store.state.paramModule.param.menu.url === 'departDoctor'){
            this.$router.push('maintaing')
            return
          }*/
           // 按卫健委领导要求暂时停用人民医院挂号功能 2022年4月21日14:07:34
            /*if(this.selectedHospital.hospitalId=='1003'&&this.$store.state.paramModule.param.menu.url === 'departDoctor'){
                this.$router.push('maintaing')
                return
            }*/

          // 彭州市人民医院才有住院查询功能，其他医院提示建设中
          if(!(this.selectedHospital.hospitalId=='1003')&&this.$store.state.paramModule.param.menu.url === 'HospitalCostList'){
              this.$router.push('maintaing')
              return
          }

          // 按医院委领导要求暂时停中西医结合医院功能 2022年6月08日10:54:06
         /* if(this.selectedHospital.hospitalId=='1007'){
            this.$router.push('maintaing')
            return
          }*/
           /* if(this.selectedHospital.hospitalId=='1003'&&type==='TFY'){
              this.$router.push('maintaing')
              return
           }*/
            // if(this.selectedHospital.hospitalId=='1003') {
            //   // this.$router.push('maintaing')
            //   window.location.replace("http://pzsrmyy.eyedsion.com/")
            //   return
            // }

            // if(this.$store.state.paramModule.param.menu.url === 'InpatientRegister' && this.selectedHospital.hospitalId=='1003') {
            //   this.$router.push('maintaing')
            //   return
            // }
            // if(this.$store.state.paramModule.param.menu.url === 'InpatientRecharge' && this.selectedHospital.hospitalId=='1003') {
            //     this.$router.push('maintaing')
            //     return
            // }
            // 2026年3月26日16:07:06 按卫健委要求，彭州就医通中，彭州人民医院弹出提示维护中
            if(this.selectedHospital.hospitalId === this.constant.HOSPITAL_ID.RMYY) {
                this.$router.push('maintaing')
                return
            }

            //判断是否跳转第三方医院页面
            if (this.selectedHospital.jumpType === this.constant.JUMP_TYPE.OUT_LINK && this.selectedHospital.hospitalId !== this.constant.HOSPITAL_ID.JKSC) {
                 //区分消息推送和正常页面跳转成大附院页面
                this.$store.commit('updateParam', {
                    namespace: 'Hospital',
                    query: {
                        selectedHospital:this.selectedHospital,
                    }
                })
                this.$router.replace('HospitalPage')
                return
            }
            //跳转健康四川挂号
            if (this.selectedHospital.jumpType === this.constant.JUMP_TYPE.OUT_LINK && this.selectedHospital.hospitalId === this.constant.HOSPITAL_ID.JKSC && this.busiType === this.BUSI_TYPE.register) {
                this.$store.commit('updateParam', {
                    namespace: 'Hospital',
                    query: {
                        selectedHospital:this.selectedHospital,
                    }
                })
                this.$router.replace('HealthySichuanRegister')
                return
            }
            //跳转健康四川挂号记录
            if (this.selectedHospital.jumpType === this.constant.JUMP_TYPE.OUT_LINK && this.selectedHospital.hospitalId === this.constant.HOSPITAL_ID.JKSC && this.busiType === this.BUSI_TYPE.myRegister) {
                this.$store.commit('updateParam', {
                    namespace: 'Hospital',
                    query: {
                        selectedHospital:this.selectedHospital,
                    }
                })
                this.$router.replace('HealthySichuanMyRegister')
                return
            }
            // 院内导航与在院导航功能依赖于院区
            if (this.$store.state.paramModule.param.menu.url === 'inMap' || this.$store.state.paramModule.param.menu.url === 'outMap') {
                // 没有院区无法使用这两个功能
                if(this.selectedHospital.areaList.length === 0) {
                    this.$utils.alert('当前选择的医院暂无院区');
                    return
                }
                // 跳转至院区选择页面，传递所选医院和院区列表
                this.$store.commit('clearParam', 'areaSelect')
                this.$store.commit('updateParam', {
                    namespace: 'areaSelect',
                    selectedHospital: this.selectedHospital,
                    areaList: this.selectedHospital.areaList
                })
                this.$router.push('AreaSelect')
                // this.showWindow = true;
                return
            }

            if(this.$store.state.paramModule.param.menu.url === 'departDoctor'&&this.selectedHospital.hintType=='1'){
              this.$store.commit('updateParam', {
                namespace: 'registeredPrompt',
                hintContent: this.selectedHospital.hintContent,
                hospitalName: this.selectedHospital.hospitalName
              })
              this.$router.replace('registeredPrompt')
              return
            }
            //默认跳转
            this.$router.push(this.$store.state.paramModule.param.menu.url);
        },
        // selectArea (area) {
        //     localStorage.selectedArea = JSON.stringify(area);
        //     this.$router.push(this.$store.state.paramModule.param.menu.url);
        // },
    }
}
</script>

<style lang="scss">
    @import '../../../static/sass/_variable.scss';
    .guide-bg{
        color: #fff;
        margin-bottom: 5px;
        border-radius: 5px;
        background: $main-style-color;
        box-shadow: inset 0 0 0 0 hsla(0, 0%, 100%, 0.1),
        inset 0 0 0 hsla(0, 0%, 82%, 0.1),
        inset 0 0 0 hsla(0, 0%, 100%, 0.01),
        inset 0 -0.03em 0 hsla(0, 0%, 100%, 0.17),
        inset 0 -0.3em 0 hsla(216, 73%, 32%, 0.19)
    }
</style>



// WEBPACK FOOTER //
// hospitalSelect.vue?53127150